/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForZohoServiceDeskIncidentManagement extends models.GovernanceConfigurationBaseForZohoServiceDesk {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForZohoServiceDeskIncidentManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForZohoServiceDeskIncidentManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForZohoServiceDeskIncidentManagement>): GovernanceConfigurationForZohoServiceDeskIncidentManagement {
        let obj = Object.assign(new GovernanceConfigurationForZohoServiceDeskIncidentManagement(), model);
        GovernanceConfigurationForZohoServiceDeskIncidentManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForZohoServiceDeskIncidentManagement>): GovernanceConfigurationForZohoServiceDeskIncidentManagement {
        if (!model) return null;
        return GovernanceConfigurationForZohoServiceDeskIncidentManagement.newInstance(<GovernanceConfigurationForZohoServiceDeskIncidentManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForZohoServiceDeskIncidentManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForZohoServiceDeskIncidentManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForZohoServiceDeskIncidentManagement): boolean {
        if (models.GovernanceConfigurationBaseForZohoServiceDesk.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForZohoServiceDeskIncidentManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.incident_management) {
            models.ZohoServiceDeskIncidentManagementConfiguration.fixupPrototype(this.incident_management);
        }
        if (this.policy_mapping) {
            models.ZohoServiceDeskPolicyMapping.fixupPrototype(this.policy_mapping);
        }
        if (this.alerts_mapping) {
            models.ZohoServiceDeskAlertMapping.fixupPrototype(this.alerts_mapping);
        }
        if (this.budget_alerts_mapping) {
            models.ZohoServiceDeskBudgetAlertMapping.fixupPrototype(this.budget_alerts_mapping);
        }
    }

    /**
     * Incident management for ZOHO ServiceDesk settings
     */
    incident_management: models.ZohoServiceDeskIncidentManagementConfiguration;

    /**
     * Attribute mapping for ZOHO ServiceDesk Policy
     */
    policy_mapping: models.ZohoServiceDeskPolicyMapping;

    /**
     * Attribute mapping for ZOHO ServiceDesk Alerts
     */
    alerts_mapping: models.ZohoServiceDeskAlertMapping;

    /**
     * Attribute mapping for ZOHO ServiceDesk Budget Alerts
     */
    budget_alerts_mapping: models.ZohoServiceDeskBudgetAlertMapping;

}
